export enum ProbabilityScenario {
    OneTouch,
    OutOfRange
}
